import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  CLIENT_MASTER_LIST_REQUEST,
  CLIENT_MASTER_LIST_SUCCESS,
  CLIENT_MASTER_LIST_FAILURE,
  CLIENT_MASTER_LIST_RESET,
  CLIENT_MASTER_CREATE_REQUEST,
  CLIENT_MASTER_CREATE_SUCCESS,
  CLIENT_MASTER_CREATE_FAILURE,
  CLIENT_MASTER_CREATE_RESET,
  CLIENT_MASTER_GET_REQUEST,
  CLIENT_MASTER_GET_SUCCESS,
  CLIENT_MASTER_GET_FAILURE,
  CLIENT_MASTER_GET_RESET,
  CLIENT_MASTER_EDIT_REQUEST,
  CLIENT_MASTER_EDIT_SUCCESS,
  CLIENT_MASTER_EDIT_FAILURE,
  CLIENT_MASTER_EDIT_RESET,
  CLIENT_MASTER_DELETE_REQUEST,
  CLIENT_MASTER_DELETE_SUCCESS,
  CLIENT_MASTER_DELETE_FAILURE,
  CLIENT_MASTER_DELETE_RESET,
} from './../../constants'

export function createClient(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/clients`,
      method: 'POST',
      types: [
        CLIENT_MASTER_CREATE_REQUEST,
        CLIENT_MASTER_CREATE_SUCCESS,
        CLIENT_MASTER_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getClient(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/clients`,
      method: 'GET',
      types: [
        CLIENT_MASTER_LIST_REQUEST,
        CLIENT_MASTER_LIST_SUCCESS,
        CLIENT_MASTER_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getClientByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/clients/${id}`,
      method: 'GET',
      types: [
        CLIENT_MASTER_GET_REQUEST,
        CLIENT_MASTER_GET_SUCCESS,
        CLIENT_MASTER_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editClient(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/clients/${id}`,
      method: 'PUT',
      types: [
        CLIENT_MASTER_EDIT_REQUEST,
        CLIENT_MASTER_EDIT_SUCCESS,
        CLIENT_MASTER_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deleteClient(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/clients/${id}/delete`,
      method: 'PUT',
      types: [
        CLIENT_MASTER_DELETE_REQUEST,
        CLIENT_MASTER_DELETE_SUCCESS,
        CLIENT_MASTER_DELETE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

// export function exportCompany(access_token) {
//   return {
//     [CALL_API]: {
//       endpoint: `${BASE_URL}/companys/exports`,
//       method: 'GET',
//       types: [
//         COMPANY_EXPORT_REQUEST,
//         COMPANY_EXPORT_SUCCESS,
//         COMPANY_EXPORT_FAILURE,
//       ],
//       headers: {
//         'authorization': `bearer ${access_token}`,
//       },
//     },
//   }
// }
export function resetGetClient() {
  return {
    type: CLIENT_MASTER_LIST_RESET,
  }
}
export function resetGetClientByID() {
  return {
    type: CLIENT_MASTER_GET_RESET,
  }
}

export function resetCreateClient() {
  return {
    type: CLIENT_MASTER_CREATE_RESET,
  }
}
export function resetEditClient() {
  return {
    type: CLIENT_MASTER_EDIT_RESET,
  }
}
export function resetDeleteClient() {
  return {
    type: CLIENT_MASTER_DELETE_RESET,
  }
}




// WEBPACK FOOTER //
// ./src/actions/client/client-master-action.js